import { findStepConfig } from "@planning/config";
import {
  useProposalBuilderContext,
  useProposalFormContext,
} from "../../providers/proposal-provider";

export function ProposalHeader() {
  const { uiState } = useProposalBuilderContext();

  const form = useProposalFormContext();

  const getHeaderText = () => {
    const config = findStepConfig(uiState);
    if (!config) throw new Error(`Config not found for UI state: ${uiState}`);
    return config.label(form.getValues());
  };

  return (
    <div className="px-6 pt-6">
      <span className="text-lg font-semibold mr-2">{getHeaderText()}</span>
    </div>
  );
}
